import getInitials from 'initials';
import { FC, useMemo } from 'react';

import { HStack } from './HStack';
import { Icon, IconProps } from './Icon';
import { Paragraph } from './Typography';
import { VStack } from './VStack';
import { cn } from './cn';

type TenantCardProps = {
  icon?: {
    name: IconProps['name'];
  };
  showBadge?: boolean;
  tenantLogoUrl?: string;
  tenantName: string;
  userDisplayName: string;
};

export const TenantCard: FC<TenantCardProps> = ({
  icon,
  showBadge,
  tenantLogoUrl,
  tenantName,
  userDisplayName,
}) => {
  const initials = useMemo(
    () => getInitials(tenantName).slice(0, 3),
    [tenantName],
  );

  return (
    <HStack align="center" className="shrink-0">
      <VStack
        align="center"
        className={cn(
          'relative size-11 shrink-0 overflow-hidden rounded-lg',
          tenantLogoUrl
            ? 'border border-border-primary'
            : 'bg-bg-strong-secondary text-text-strong',
        )}
        justify="center"
      >
        {tenantLogoUrl ? (
          <img
            alt="logo"
            className="size-8 object-contain"
            src={tenantLogoUrl}
          />
        ) : (
          <Paragraph className="uppercase" color="inherit" weight="semibold">
            {initials}
          </Paragraph>
        )}
        {showBadge && (
          <div className="absolute -right-0.5 -top-0.5 size-3 rounded-bl rounded-tr-lg border-2 border-bg-secondary bg-bg-negative-strong-primary" />
        )}
      </VStack>
      <VStack align="stretch" className="min-w-0" gap={0}>
        <Paragraph className="truncate" size="md" weight="semibold">
          {tenantName}
        </Paragraph>
        <Paragraph className="truncate" color="tertiary" size="sm">
          {userDisplayName}
        </Paragraph>
      </VStack>
      {icon && (
        <Icon
          className="shrink-0 text-text-tertiary"
          name={icon.name}
          size="sm"
        />
      )}
    </HStack>
  );
};
